<!-- 开通会员的弹出层 -->
<template>
  <el-dialog
    @close="closevipBtn"
    :visible="isispopvip"
    :close-on-click-modal="false"
  >
    <div class="newvipbg">
      <!-- topname -->
      <div class="topname">
        <div class="nameleft">
          <img class="gjsladk" src="@/assets/viptext.svg" alt="" />

          <!-- <div class="newnameltxt1">
          超清录屏快速共享
        </div>

        <div class="newnameltxt2">
            全局录屏、自定义区域录屏随心选择 录屏文件智能压缩快速存储
        </div> -->

          <!-- <img class="viplogo" src="@/assets/components/vip/viplogo.png" alt="">
          <div class="namedq">
              <div class="namename">{{isuserInfo.username}}</div>
              <div class="dq" v-if="!isuserInfo.isVip">未开通会员</div>
              <div class="dq" v-if="isuserInfo.isVip">会员到期：{{isuserInfo.order.payment_time.match(/(\d{4}-\d{2}-\d{2})/)[0]}} - {{computeVipTime}}</div>
          </div> -->
        </div>
        <div class="nameright" @click="closevipBtn">
          <img src="@/assets/components/vip/vipnewclose.png" alt="" />
        </div>
      </div>

      <!-- 下面区域 -->
      <div class="vipcontent">
        <div class="vipcontentLeft">
          <div class="leftbt">会员权益</div>

          <div class="jieshaoitemContent">
            <div
              class="jiesItem"
              v-for="(item, index) in newjieshaolist"
              :key="index"
            >
              <img src="@/assets/components/vip/duigou.png" alt="" />
              <span>{{ item }}</span>
            </div>
          </div>
        </div>

        <div class="vipcontentRight">
          <!-- 右边顶上 -->
          <div class="righttop">
            <div
              :class="[
                'paytemplateItem',
                xzMeal === index + 1 ? 'paytemplateActive' : '',
              ]"
              @click="mealItemBtn(item, index)"
              v-for="(item, index) in templateList"
              :key="index"
            >
              <div class="titlebgt">{{ item.type_name }}</div>
              <div class="newjiage">
                ￥<span style="font-size: 22px; font-weight: 600">{{
                  item.spare_label
                }}</span
                >/天
              </div>
              <div class="newxianjia">现价{{ item.price }}元</div>
              <div class="newyuanjia">{{ item.bottom_label }}</div>
            </div>
          </div>

          <!-- 右边下面 -->
          <div class="rightbottom">
            <div class="wxhszfb">
              <div
                :class="[
                  'wxhszfbItem',
                  wxiszfb === 1 ? 'wxhszfbItemactive' : '',
                ]"
                @click="btnwxIszfb(1)"
              >
                <img src="@/assets/components/vip/wx.png" alt="" />
                <span>微信支付</span>
              </div>
              <div
                :class="[
                  'wxhszfbItem',
                  wxiszfb === 2 ? 'wxhszfbItemactive' : '',
                ]"
                @click="btnwxIszfb(2)"
              >
                <img src="@/assets/components/vip/zfb.png" alt="" />
                <span>支付宝支付</span>
              </div>
            </div>

            <div class="contentcontent">
              <div
                class="ewmzs"
                id="payewm"
                ref="payewm"
                v-loading="ewmloading"
              >
                <img
                  class="wxewm"
                  ref="wxpayImg"
                  v-if="wxiszfb === 1"
                  :src="wxzhifuerweima"
                  alt=""
                />
                <iframe
                  width="79%"
                  height="81%"
                  style="margin-top: 5px; margin-left: 3px"
                  ref="zfbiframe"
                  id="zfbiframe"
                  :src="zfbfukuanma"
                  frameborder="0"
                  v-else
                ></iframe>
              </div>
              <div class="dnajia">
                <div class="danjiatop">
                  <div class="titledanjia">
                    应付：<span style="font-size: 25px; color: #f56a39"
                      >￥{{ copewith }}</span
                    >
                  </div>
                  <div class="kaitsm">
                    开通{{ templateList[xzMeal - 1]?.type_name }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 右边最下面小字 -->

          <div class="righttext">
            <div>
              支付即视为同意<span class="txtyans">《用户协议》</span
              >如遇到支付问题在线反馈
            </div>
            <div>如遇到支付问题在线反馈</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="vipbg">

   <div class="closevip" @click="closevipBtn"></div>

    <div class="mobanjiagecontent">

      <div class="mobancontent">
        <div 
        @click="mealItemBtn(item,index)"
        :class="['mobanitem', xzMeal ===index +1?'mobanactive':'']"
         v-for="(item,index) in templateList" :key="index">
          <div class="topjs">
            <div class="riyuenian">{{item.type_name}}</div>
            <div class="toptxt">{{jiagejieshao[index]}}</div>
          </div>

          <div class="jine">
              ￥{{item.price}}
          </div>

          <div class="yuanjiacontent">
            <div class="yuanjia">原价{{item.bottom_label}}元</div>
            <div class="dizhi" v-if="item.spare_label !==''">低至{{item.spare_label}}元每天</div>
          </div>

          <div class="lijidinggou">
              立即订购
          </div>

          <div class="dianjieshaoitem" 
          
          v-for="(ii,jj) in jiagejieshaolist[index]"
          :key="jj"
          >
              <div class="dian"></div>
              <div class="diantxt">{{ii}}</div>
          </div>

        </div>

      </div>


      <div class="jineermcontent">
          <div class="jineewmleft">
              <div class="yingfu">应付金额</div>
              <div class="jiage">
                  <span class="fs20">￥</span>
                  <span>{{copewith}}</span>
              </div>

              <div class="xtxt" @click="btnfuwu">购买即同意并接受《服务条款》</div>
          </div>


          <div class="jineewmright">

            <div class="wxewm">
            <img
                class="wxzfewm"
            ref="wxpayImg"
            v-if="wxiszfb === 1"
            :src="wxzhifuerweima"
            alt=""
          />
          <div class="zhifutxt">
            <img  src="@/assets/components/vip/wx.png" alt="">
              <span>微信支付</span>
          </div>
            </div>

            <div class="zfb" v-loading="ewmloading">
         <div class="iframecontentcontent">
           <div class="iframecontent">
            <iframe
            width="100%"
            height="100%"
            ref="zfbiframe"
            id="zfbiframe"
            :src="zfbfukuanma"
            frameborder="0"
          ></iframe>
          </div>
         </div>

           <div class="zhifutxt">
            <img src="@/assets/components/vip/zfb.png" alt="">
              <span>支付宝支付</span>
          </div>
            </div>

          </div>
      </div>


    </div>

    </div> -->
  </el-dialog>
</template>

<script>
import {
  priceTemplate,
  getPriceUrl,
  inquirePaySuces,
  bingApi,
} from "@/api/pay";
import QRCode from "qrcode"; //生成二维码的库
import { mapGetters, mapMutations } from "vuex";
import assist from "@/utils/commonality";
export default {
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      wxiszfb: 1, //1是微信 2是支付宝
      xzMeal: 1, //选择哪个套餐
      templateList: [],
      payEwm: "", //支付的二维码
      wxiszfbEwm: {
        wx: { url: "", out_trade_no: "" },
        ali: { url: "", out_trade_no: "" },
      },
      wxzhifuerweima: "", //微信支付的二维码
      zfbfukuanma: "", //支付宝支付的二维码
      ewmloading: false, //二维码加载状态
      copewith: "", //应付金额
      timeout: 2e3, //轮询时间
      interval: null,
      times: 0, //轮询初始值
      maxTimes: 300, //最大轮询次数
      chengggongshibai: false, //支付成功与超时的
      jiagejieshaolist: [
        ["Word分类畅享下载", "会员免费下载", "海量模板"],
        ["专享高速下载", "尊贵会员标识", "智能搜索"],
        ["专业合同模板", "终身会员下载不限量", "海量模板任您挑选"],
      ],
      jiagejieshao: [
        "下载即可使用，模板严谨专业",
        "一键下载，无需等待",
        "海量模板，任您挑选",
      ],

      // 新版

      newjieshaolist: [
        "滚动录屏极速体验",
        "解锁录屏无时长限制",
        "一键去除水印、添加水印",
        "照片快速拼长图",
        "照片AI智能抠图",
        // '图片格式转换',
        "视频、图片加密安全处理",
        "会员专属客服",
      ],
      newpaiceList: [],
    };
  },
  computed: {
    ...mapGetters(["isconfigforChannel", "isispopvip", "isuid", "isuserInfo"]),
    computeVipTime() {
      if (this.isuserInfo?.order?.vip_time === 999999999999) {
        return "永久会员";
      }
      // 获取并检查时间戳
      const vipTimestamp = Number(this.isuserInfo.vip_time); // 确保是数字类型

      // 转换时间戳为毫秒
      const date = new Date(vipTimestamp * 1000); // 乘以 1000 以转换为毫秒

      // 获取年份
      const year = date.getFullYear();

      // 获取月份，注意月份从 0 开始，所以需要加 1
      const month = String(date.getMonth() + 1).padStart(2, "0");

      // 获取日期
      const day = String(date.getDate()).padStart(2, "0");

      // 返回格式化后的日期
      return `${year}.${month}.${day}`;
    },
  },
  watch: {
    async isispopvip(newValue) {
      if (newValue) {
        await this.gettemplateList();
        if (this.interval !== null) clearTimeout(this.interval);
        this.interval = setTimeout(() => {
          this.payisSuces();
        }, this.timeout);

        this.ewmloading = true;
        this.$nextTick(() => {
          if (this.$refs.zfbiframe) {
            this.$refs.zfbiframe.removeEventListener("load", this.deleteSj);
          }
          setTimeout(() => {
            this.$nextTick(() => {
              if (this.$refs.zfbiframe) {
                this.$refs.zfbiframe.addEventListener("load", this.deleteSj);
                this.ewmloading = false;
              } else {
                this.deleteSj();
              }
            });
          }, 500);
        });
      } else {
        this.newpaiceList = [];
        this.xzMeal = 1;
        clearTimeout(this.interval);
      }
    },
    wxiszfb(newval) {
      if (newval === 2) {
        this.ewmloading = true;
        this.$nextTick(() => {
          if (this.$refs.zfbiframe) {
            this.$refs.zfbiframe.removeEventListener("load", this.deleteSj);
          }
          setTimeout(() => {
            this.ewmloading = false;
            this.$nextTick(() => {
              if (this.$refs.zfbiframe) {
                this.$refs.zfbiframe.addEventListener("load", this.deleteSj);
              } else {
                this.deleteSj();
              }
            });
          }, 500);
        });
      }
    },

    ["wxiszfbEwm.wx.out_trade_no"](newval) {
      if (!this.newpaiceList.includes(newval)) {
        this.newpaiceList.push(newval);
        if (this.newpaiceList.length > 20) {
          this.newpaiceList.shift();
        }
      }
    },

    ["wxiszfbEwm.ali.out_trade_no"](newval) {
      if (!this.newpaiceList.includes(newval)) {
        // Add the new value
        this.newpaiceList.push(newval);

        // If the length exceeds 50, remove the first (oldest) element
        if (this.newpaiceList.length > 20) {
          this.newpaiceList.shift();
        }
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    async getbing(price, out_trade_no, callback) {
      //价格 订单号 回调方法  需要支付价格跟订单号
      let res = "";
      if (assist.getPacket() == "bing") {
        console.log("进来的");
        window.uetq = window.uetq || [];
        window.uetq.push("event", "purchase", {
          revenue_value: price,
          currency: "CNY",
        });
        let res = await bingApi({
          out_trade_no: out_trade_no,
        });
        if (res.data.status === 1) {
        }
      }
      // 成功以后自定义逻辑
      //需要判断
      /**
       * 判断当前的环境是不是必应  判断回传成功没
       */
      // callback && callback();
      return res;
    },
    deleteSj() {
      this.ewmloading = false;
    },
    ...mapMutations(["updatispopvip", "updatedetainment"]),
    async gettemplateList() {
      //三种价格的模板 请求获取模板
      let res = await priceTemplate();
      let topIndices = [];
      // 遍历列表
      res.data.list.forEach((item, index) => {
        // 如果 is_top 为 1，则将当前索引添加到 topIndices 数组中
        if (item.is_top == 1) {
          topIndices.push(index);
        }
      });

      console.log(topIndices);
      if (topIndices.lengt === 0) {
        topIndices[0] = 0;
      }

      this.xzMeal = topIndices[0] + 1;
      this.templateList = res.data.list;
      this.templateList.splice(this.templateList.length - 1, 1);
      await this.getewm(this.templateList[topIndices[0]].id);
      this.copewith = this.templateList[topIndices[0]].price;
    },
    async getewm(shopid) {
      this.ewmloading = true; //开启loading加载
      try {
        let res = await getPriceUrl(shopid);
        this.wxiszfbEwm = res.data;
        // 生成二维码图片
        let url = await new Promise((resolve, reject) => {
          QRCode.toDataURL(res.data.wx.url, (err, url) => {
            if (err) {
              reject(err);
            } else {
              resolve(url);
            }
          });
        });
        // 设置图片的 src
        this.wxzhifuerweima = url;
        this.zfbfukuanma = res.data.ali.url;
        this.ewmloading = false; //加载状态结束
      } catch (error) {
        this.$tips(error.message);
      }
    },
    mealItemBtn(item, index) {
      //点击了哪个价格模板
      if (this.xzMeal !== index + 1) {
        //当点击的还是原来的元素的时候就禁止点击
        this.xzMeal = index + 1;
        this.getewm(item.id);
        this.zfbfukuanma = this.wxiszfbEwm.ali.url;
        this.copewith = item.price;
      }
    },
    btnwxIszfb(index) {
      //微信支付还是支付宝支付
      this.wxiszfb = index;
    },
    async payisSuces() {
      try {
        let res = await inquirePaySuces(this.newpaiceList.join(","));

        if (res.code === 200) {
          let data = res.data;
          data = assist.search(data, "status", 2, true); // 过滤状态为2的数据
          data = assist.like(data, "payment_time", assist.date()); // 过滤支付时间为当天的数据

          if (assist.count(data) >= 1) {
            // 支付成功
            // 处理支付成功的逻辑
            clearTimeout(this.interval); // 停止定时器
            this.interval = null; // 重置定时器标识
            this.times = 0; // 重置轮询次数
            this.getbing(this.copewith, res.data.out_trade_no);
            //支付成功逻辑
            this.$tips("支付成功");
            this.chengggongshibai = true;
            this.updatispopvip(false);
            this.$store.dispatch("getuserinfo");
            this.$store.commit("updateshifougengxinfenzu", true); //更新分组
            this.$store.commit("updateshifougengxinliebiao", true);
          } else if (this.times >= this.maxTimes) {
            // 超过最大轮询次数
            // 处理支付超时的逻辑
            console.log("支付超时");
            clearTimeout(this.interval); // 停止定时器
            this.interval = null; // 重置定时器标识
            this.times = 0; // 重置轮询次数
            this.chengggongshibai = true;
            this.$tips("支付超时");
            this.updatispopvip(false);
          } else {
            ++this.times; // 增加轮询次数
            this.interval = setTimeout(() => {
              this.payisSuces(); // 继续轮询
            }, this.timeout);
          }
        } else {
          console.log("订单返回失败");
        }
      } catch (error) {
        console.error("查询支付状态时发生错误：", error);
      }
    },

    closevipBtn() {
      this.updatispopvip(false); //关闭当前弹窗
      if (!this.chengggongshibai) {
        //如果是因为支付成功的  就不显示挽留弹窗了
        this.updatedetainment(true);
      }
      this.chengggongshibai = false;
    },
    btnfuwu() {
      //跳转服务条款
      if (
        this.isconfigforChannel?.standard_conf?.agreement_content?.func
          .pay_agreement == 0
      ) {
        window.location.href =
          this.isconfigforChannel?.standard_conf?.agreement_content?.func.pay_agreement;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$txtcolor: #0068ff;

::v-deep .el-dialog {
  // width :59vw  !important;
  // border-radius: 20px !important;
  // min-width: 1000px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  min-width: 1000px;
  min-height: 650px;
  margin-top: 0 !important ;
}
::v-deep .el-dialog__headerbtn {
  font-size: 25px !important;
  font-weight: 800 !important;
  color: #fff !important;
}
::v-deep .el-dialog__body {
  padding: 0 0 15px 0 !important;
}

.vipbg {
  position: relative;
  width: 950px;
  height: 700px;
  background: url("@/assets/components/vip/newvipbg.png") no-repeat;
  background-size: 100% 100%;
}
::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-dialog {
  box-shadow: 0;
  background-color: rgba(0, 0, 0, 0);
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0);
}

.closevip {
  position: absolute;
  right: 3%;
  top: 3%;
  background: url("@/assets/components/vip/close.png") no-repeat;
  background-size: 100% 100%;
  width: 36px;
  height: 36px;
  cursor: pointer;
}

.mobanjiagecontent {
  position: absolute;
  top: 21%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 75%;
  margin: 0 auto 0;

  .mobancontent {
    width: 100%;
    height: 62%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .mobanactive {
      background: url("@/assets/components/vip/vipborder.png") no-repeat;
      background-size: 100% 100%;

      .lijidinggou {
        background: linear-gradient(
          to right,
          #2856f5,
          #3c47f3,
          #4f38f0
        ) !important;
        color: #fff !important;
        border: none !important;
        border-radius: 8px;
      }
    }
    .mobanitem {
      cursor: pointer;
      width: 31%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.4);
      border-radius: 10px;
      padding: 15px;
      .topjs {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .riyuenian {
          font-weight: 600;
          font-size: 18px;
          color: $txtcolor;
        }
        .toptxt {
          font-size: 12px;
          color: #2f1a06;
        }
      }

      .jine {
        font-size: 25px;
        font-weight: 600;
        margin: 5px 0;
        color: $txtcolor;
      }

      .yuanjiacontent {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .yuanjia {
          color: $txtcolor;
          text-decoration: line-through;
        }
        .dizhi {
          color: #2f1a06;
        }
      }

      .lijidinggou {
        position: relative;
        cursor: pointer;
        margin-top: 10px;
        width: 100%;
        height: 50px;
        background: url("@/assets/components/vip/vipsmallborder.png") no-repeat;
        background-size: 100% 100%;

        display: flex;
        align-items: center;
        justify-content: center;
        color: $txtcolor;
        line-height: 50px;
        font-weight: 600;
      }

      .dianjieshaoitem {
        display: flex;
        align-items: center;
        margin-top: 15px;
        .dian {
          width: 10px;
          height: 10px;
          background-color: $txtcolor;
          border-radius: 50%;
          margin-right: 15px;
        }
        .diantxt {
          color: #fff;
        }
      }
    }
  }

  .jineermcontent {
    margin-top: 19px;
    padding: 10px;
    height: 130px;
    display: flex;
    .jineewmleft {
      width: 25%;
      border-right: 1px solid #cbcbcb;
      height: 110%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .yingfu {
        font-size: 16px;
        color: #fff;
        font-weight: 600;
      }
      .jiage {
        font-size: 30px;
        font-weight: 600;
        display: flex;
        justify-content: center;
        color: #ff3838;
      }

      .xtxt {
        cursor: pointer;
        font-size: 10px;
        color: #9e9e9e;
        text-align: center;
      }
    }

    .jineewmright {
      width: 74%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 34px;
      .wxewm {
        width: 155px;
        height: 155px;
        .wxzfewm {
          width: 100%;
          height: 100%;
        }
      }

      .zfb {
        width: 155px;
        height: 155px;
        .iframecontentcontent {
          width: 155px;
          height: 155px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
        }

        .iframecontent {
          width: 130px;
          height: 126px;
        }
        .zhifutxt {
          margin-top: 2px;
        }
      }

      .zhifutxt {
        display: flex;
        align-items: center;
        padding-left: 20px;
        img {
          width: 20px;
        }
        span {
          margin-left: 15px;
          color: #fff;
          font-size: 14px;
        }
      }
    }
  }
}

// 新vip面板
.newvipbg {
  width: 880px;
  height: 580px;
  // width: 90%;
  // height: 74vh;
  // min-width:950px;
  // min-height: 590px;
  background: url("@/assets/components/vip/paynewbg.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 15px;
  overflow: hidden;
  margin: 0 auto;

  .topname {
    width: 100%;
    height: 15%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px;

    .nameleft {
      display: flex;
      flex-direction: column;
      .gjsladk {
        width: 390px;
      }

      .newnameltxt1 {
        color: #fff;
        font-weight: 600;
        font-size: 22px;
      }
      .newnameltxt2 {
        color: #fff;
        margin-top: 5px;
      }

      .viplogo {
        width: 53px;
        margin-right: 14px;
      }
      .namedq {
        color: #fff;
        .namename {
          font-size: 16px;
        }
        .dq {
          margin-top: 6px;
          color: #fff;
          font-size: 14px;
        }
      }
    }

    .nameright {
      cursor: pointer;
      img {
        width: 34px;
      }
    }
  }

  // 下面区域

  .vipcontent {
    margin: 0 auto;
    width: 95%;
    height: 81%;
    padding-top: 21px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .vipcontentLeft,
    .vipcontentRight {
      height: 100%;
    }
    .vipcontentLeft {
      width: 22%;
      background: url("@/assets/components/vip/vipnewleft.png") no-repeat;
      background-size: 100% 100%;
      padding: 35px 10px;
      .leftbt {
        font-size: 20px;
        font-weight: 600;
        background: linear-gradient(to right, red, #f56838, #fbac54);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
      }

      .jieshaoitemContent {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 90%;
        margin-top: 7%;

        .jiesItem {
          display: flex;
          align-items: center;
          padding-left: 3%;
          span {
            color: #fff;
            font-size: 12px;
          }
          img {
            margin-right: 10px;
            width: 15px;
          }
        }
      }
    }

    .vipcontentRight {
      width: 76%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      .righttop,
      .rightbottom {
        width: 100%;
      }

      .righttop {
        height: 34%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .paytemplateActive {
          background-image: linear-gradient(
            to right top,
            #fc3b5e,
            #f45731,
            #fcaf55
          ) !important;
          * {
            color: #fff !important;
          }
        }
        .paytemplateItem {
          cursor: pointer;
          width: 28%;
          height: 100%;
          background: url("@/assets/components/vip/mobanthree.png") no-repeat;
          background-size: 100% 100%;
          border-radius: 15px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .titlebgt {
            color: #fff;
          }
          .newjiage {
            display: flex;
            align-items: center;
            color: #fff;
            margin: 6% 0;
          }
          .newxianjia {
            margin-bottom: 2%;
            color: #fff;
          }
          .newyuanjia {
            color: #fff;
            text-decoration: line-through;
          }
        }
      }

      .rightbottom {
        height: 55%;
        background: url("@/assets/components/vip/bottombg.png") no-repeat;
        background-size: 100% 100%;
        padding: 4%;

        .contentcontent {
          display: flex;
          align-items: end;
          margin-top: 15px;
        }

        .ewmzs {
          width: 155px;
          height: 155px;
          background-color: #fff;
          margin-right: 0%;
          display: flex;
          align-items: center;
          justify-content: center;
          transform: scale(0.8);
          .wxewm {
            width: 100%;
          }
        }

        .dnajia {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 1% 0;
          margin-bottom: 10px;
          .titledanjia {
            font-weight: 600;
            font-size: 20px;
            color: #fff;
          }
          .kaitsm {
            color: #fff;
            margin-top: 10px;
          }
        }

        .wxhszfb {
          display: flex;
          align-items: center;
          // background-color: #201f22;
          border-radius: 6px;
          width: 96%;
          margin: 0 auto;
          background-color: #1c1e1d;

          .wxhszfbItem {
            width: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding: 10px 25px;
            display: flex;
            align-items: center;
            border-radius: 6px;
            img {
              margin-right: 5px;
              width: 25px;
            }
          }

          .wxhszfbItemactive {
            background-color: #fff;
          }
        }
      }
    }

    .righttext {
      color: #fff;
      width: 100%;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .txtyans {
        color: #ff713d;
      }
    }
  }
}
</style>
